import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const textareaVariants = cva(
  "flex w-full resize-y rounded-lg border bg-white px-3 py-2.5 text-sm transition-[border-color,box-shadow] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "min-h-[120px] border-border focus-visible:border-primary",
        form: "min-h-[120px] border-input",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

const Textarea = React.forwardRef(({ className, variant, ...props }, ref) => (
  <textarea
    className={cn(textareaVariants({ variant }), className)}
    ref={ref}
    {...props}
  />
));
Textarea.displayName = "Textarea";

export { Textarea, textareaVariants };
